import { create } from 'zustand'

interface GlobalState {
  isAnyAlertDialogOpen: boolean
  setIsAnyAlertDialogOpen: (isOpen: boolean) => void
}

export const useGlobalStore = create<GlobalState>((set) => ({
  isAnyAlertDialogOpen: false,
  setIsAnyAlertDialogOpen: (isOpen: boolean) =>
    set({ isAnyAlertDialogOpen: isOpen }),
}))
